
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use environment variables with fallback to default values
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://qpnvlfrytztskaayfsxu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFwbnZsZnJ5dHp0c2thYXlmc3h1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE5NzY1MjQsImV4cCI6MjA1NzU1MjUyNH0.CZy1afCZYZ25KdZQnM_chcbRj6ACM4ClRwcjUgmpwqQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Use singleton pattern to prevent multiple instances
let supabaseInstance: ReturnType<typeof createClient<Database>> | null = null

export const supabase = (() => {
  if (!supabaseInstance) {
    supabaseInstance = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      global: {
        headers: {
          apikey: SUPABASE_PUBLISHABLE_KEY,
        },
      },
      auth: {
        persistSession: true,
        storageKey: 'supabase.auth.token',
        detectSessionInUrl: true,
      },
    })
  }
  return supabaseInstance
})()
